import { createI18n } from 'vue-i18n';
import tw from '@/js/i18n/tw.js';
import en from '@/js/i18n/en.js';
import ab from '@/js/i18n/ab.js';
import bd from '@/js/i18n/bd.js';
import es from '@/js/i18n/es.js';
import id from '@/js/i18n/id.js';
import kr from '@/js/i18n/kr.js';
import ru from '@/js/i18n/ru.js';
import th from '@/js/i18n/th.js';
import tr from '@/js/i18n/tr.js';
import uz from '@/js/i18n/uz.js';
import vn from '@/js/i18n/vn.js';

export const i18n = createI18n({
    legacy: false,
    locale: 'tw',
    fallbackLocale: 'en',
    globalInjection: true,
    useScope: 'global',
    messages: {
        en,
        tw,
        ab,
        bd,
        es,
        id,
        kr,
        ru,
        th,
        tr,
        uz,
        vn
    }
})
